import React from 'react';
import { StyledDescription } from './entity-layout.styles';
import { IEntityLayoutDescription } from './entity-layout.types';

export const EntityLayoutDescription = ({ description }: IEntityLayoutDescription) => (
    <StyledDescription description={description} shortLabel />
);
